// extracted by mini-css-extract-plugin
var _1 = "PointForm_controls__f3b73";
var _2 = "PointForm_form__f76a8";
var _3 = "PointForm_root__302cf";
export { _1 as "controls", _2 as "form", _3 as "root" }
